<template>
  <v-container>
    <v-row
      v-if="checkIfConversationExists(stakeholderResponse.survey_taker_id,
                                      stakeholderResponse.pk,
                                      stakeholderResponse.survey)"
      justify="center"
    >
      <v-btn
        outlined
        :disabled="validEmail"
        @click="
          continueConversation(
            stakeholderResponse.survey_taker_id,
            stakeholderResponse.pk,
            stakeholderResponse.survey
          )
        "
      >
        Join Conversation
      </v-btn>
    </v-row>
    <v-row
      v-else
      class="conversation-bar"
      justify="center"
    >
      <v-textarea
        v-model="topic"
        auto-grow
        rows="1"
        placeholder="Topic"
        :disabled="validEmail"
      />
      <v-btn
        outlined
        :disabled="checkTopic()"
        @click="
          startConversation(
            stakeholderResponse.survey_taker_id,
            stakeholderResponse.pk,
            stakeholderResponse.survey
          )
        "
      >
        Start Conversation
      </v-btn>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import jwt from "jwt-simple";

export default {
  name: "ConversationInteraction",
  props: {stakeholderResponse: { type: Object, default: () => {
    return { survey_taker_id: -1, pk: -1, survey: -1 }
  } }, validEmail: { type: Boolean, default: () => true } },
  data() {
    return {
      admin: null,
      topic: ""
    }
  },
  computed: {
    ...mapState({
      surveys: state => state.survey.surveys,
      conversations: state => state.conversations.conversations,
    })
  },
  beforeMount() {
    this.getAdmin();
    this.fetchConversationsWithObjects();
  },
  methods: {
    ...mapActions({
      fetchConversationsWithObjects:
        "conversations/fetchConversationsWithObjects",
      addConversation: "conversations/addConversation",

    }),
    checkIfConversationExists(stakeholder, response, surveyPk) {
      let conversation = this.getConversation(stakeholder, response, surveyPk);
      return !!conversation;
    },
    checkTopic() {
      return !this.topic || !this.topic.trim();
    },
    startConversation(stakeholder, response, surveyPk) {
      this.addConversation({
        admin: this.admin.user_id,
        stakeholder: stakeholder,
        survey_response: response,
        project: this.surveys.find(survey => survey.pk === surveyPk).project,
        topic: this.topic
      }).then(response => {
        this.encodeAndPush(response);
      });
    },
    continueConversation(stakeholder, response, surveyPk) {
      let conversation = this.getConversation(stakeholder, response, surveyPk);
      this.encodeAndPush(conversation);
    },
    encodeAndPush(conversation) {
      let encodedConversation = jwt.encode(
        conversation,
        process.env.VUE_APP_JWT_SECRET_KEY,
        "HS256"
      );
      this.$router.push({
        name: "messageroom",
        path: "/conversation",
        params: {
          stakeholder: conversation.stakeholder.get_full_name,
          project: conversation.project.name,
          topic: conversation.topic
        },
        query: {
          conversation: encodedConversation,
          sender: localStorage.getItem("TOKEN_STORAGE_KEY")
        }
      });
    },
    getConversation(stakeholder, response, surveyPk) {
      let conversation = this.conversations.find(
        conversation =>
          conversation.stakeholder.pk === stakeholder &&
          conversation.survey_response === response &&
          conversation.project.pk ===
            this.surveys.find(survey => survey.pk === surveyPk).project
      );
      return conversation;
    },
    getAdmin() {
      this.admin = jwt.decode(
        localStorage.getItem("TOKEN_STORAGE_KEY"),
        "",
        true
      );
    },
  }
}
</script>
<style scoped>
.conversation-bar {
  padding-left: 5% !important;
  padding-right: 5%;
}
</style>